import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import StatusLayout from "./StatusLayout";
import { useCase } from "../../context/CaseContext";
import { retrievePhoto } from "../../lib/everifyStatusApi";

const DocumentPhotoVerification = () => {
  const { activeCaseNumber } = useCase();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  // const handleViewDoc = async () => {
  //   if (!activeCaseNumber) {
  //     toast.error("No active case number found.");
  //     return;
  //   }
  //   try {
  //     setIsLoading(true);
  //     const photoUrl = await retrievePhoto(activeCaseNumber);
  //     if (!photoUrl) {
  //       toast.error("Photo is unavailable.");
  //       return;
  //     }
  //     navigate("/case/photo-match", { state: { photoUrl } });
  //   } catch (error) {
  //     toast.error("Unable to retrieve the photo.");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  //fallback for testing without api
  const handleViewDoc = async () => {
    if (!activeCaseNumber) {
      toast.error("No active case number found.");
      return;
    }

    try {
      setIsLoading(true);

      let photoUrl;
      try {
        // REAL API (when available)
        photoUrl = await retrievePhoto(activeCaseNumber);
      } catch (e) {
        // 🔥 FALLBACK
        console.warn("Retrieve photo failed, using fallback image");
        photoUrl = "/mock/photo-placeholder.png"; // any local/static image
      }

      navigate("/case/photo-match", { state: { photoUrl: photoUrl || null } });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <StatusLayout
      title="Document Photo Verification Required"
      description="Please compare the employee’s document photo with the government-provided document photo."
    >
      <div className="status-section">
        <h3>Next Steps</h3>
        <ul className="status-steps">
          <li className="status-step">
            <div className="status-step-body">
              <p>Click on View Doc to view the Govt. provided document photo.</p>
              <div className="status-actions">
                <button
                  className="status-primary"
                  type="button"
                  onClick={handleViewDoc}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "View Doc"}
                </button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </StatusLayout>
  );
};

export default DocumentPhotoVerification;
